/* 20200927 : LGEUS-137 add */
$(document).ready(function() {
	if(!document.querySelector('.C0093')) return false;
	
	var s = {
			form: document.getElementById('handraiserForm'),
			init: function () {
				s.form.reset();
				s.addEvent();
				s.handleWA();
				$(s.form).find('#cmpid').val(window.location.href);
			},
			addEvent: function () {
				// 20200401 END
				$(s.form).on({
					submit: function (e) {
						e.preventDefault();
						if ($(this).checkValidation()) {
							var param = xssfilter($(e.currentTarget).serialize());
							$.ajax({
								 type: "POST",
						            enctype: 'multipart/form-data',
						            url: $(".C0093 form").attr("action"),
						            data: param,
						            dataType: ($(s.form).attr('data-form-type') == "Handraiser") ? 'json' : 'jsonp',
						            success: function (data) {
						            	console.log("success");
						            },
						            error: function (request, status, error) {
										console.log("status: " + status);
										console.log("error: " + error);
						            },
						            complete:function(f){
										$(".C0093 .beform").removeClass("active");
										$(".C0093 .afform").addClass("active");
										dataLayer.push({"event": "userFormSubmission"}); // DC-908
										console.log("complete");
						            }
							});
						}
					}
				}, null, 'body');
			},
			handleWA: function() {
				var $form = $(s.form);
				var $arrows = $form.find('svg');
				$arrows.each(function() {
					var $el = $(this);
					var ariaLabelledBy = $el.parents('.chosen-single').attr('aria-labelledby');
					$el.attr('role', 'img');
					$el.attr('aria-labelledby', ariaLabelledBy);
				});
				$form.find('input[type="radio"]').attr('required', true);
			},
		}
		s.init();
});
/*// 20200927 : LGEUS-137 add */